/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

export const styles = () => css`
    position: relative;
    display: flex;
    height: 100%;
    margin: 0;
    overflow: hidden;
    border-radius: var(--effects-radius-xl);

    picture {
        display: block;
        width: 100%;
        height: 100%;

        img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    figcaption {
        position: absolute;
        bottom: 0;
        left: 0;
        ${theme.typography.body_small}
        color: var(--colors-text-secondary);
        margin: var(--layout-spacing-8);
        border-radius: var(--effects-radius-lg);
        padding: var(--layout-spacing-4) var(--layout-spacing-8);
        overflow-wrap: break-word;
        background-color: var(--colors-overlay-light);
        backdrop-filter: var(--effects-background-filter-blur);
    }
`;
